import { IndexableObject, IPriceProps, IProduct } from '../types';
import { currencyFormatter } from '@mooncake/utils/sfcc/currency';

interface IConfig {
  currency: string;
  localeId: string;
}

export const getFormattedPrice = (
  initialValue: IPriceProps,
  product: IProduct,
  storeConfig: IConfig
) => {
  const formattedPrice: IPriceProps = {
    ...initialValue,
    defaultPrice: getValueByCurrency(product.default_price, storeConfig),
    minimumPrice: getValueByCurrency(product.minimum_price, storeConfig),
    price: getValueByCurrency(product.price, storeConfig),
    priceRange: getRangeValuesByCurrency(product.price_range, storeConfig),
    salePriceEffectiveDate: product.sale_price_effective_date,
    isPromo: product.promotion_percentage !== ''
  };

  return formattedPrice;
};

const getValueByCurrency = (
  value: IndexableObject<string>[],
  config: IConfig
) => {
  if (!value) {
    return null;
  }

  const { currency, localeId } = config;
  let price;

  if (typeof value === 'number') {
    price = value;
  } else {
    price = parseFloat(value[0][currency]);
  }

  if (isNaN(price)) {
    return null;
  }

  return currencyFormatter(
    price,
    getFormattedLocaleId(localeId),
    currency,
    {
      shouldKeepEmptyDecimals: false
    }
  );
};

const getRangeValuesByCurrency = (
  value: IndexableObject<string>[],
  config: IConfig
): [string, string] => {
  if (!value.length) {
    return null;
  }
  const { currency, localeId } = config;
  const range = value[0][currency]
    .split(' – ')
    .map((price) => parseFloat(price.replace(/\D/g, '')));

  if (isNaN(range[0]) || isNaN(range[1])) {
    return null;
  }

  const stringifiedRange = range.map((price) =>
    currencyFormatter(price, getFormattedLocaleId(localeId), currency)
  );

  return [stringifiedRange[0], stringifiedRange[1]];
};

const getFormattedLocaleId = (localeId: string) =>
  localeId.indexOf('_') > 0
    ? localeId.replace('_', '-').toLowerCase()
    : localeId;
